import React, { useEffect, useState } from 'react';
import { getInitials, isNotEmpty } from '../../lib/ep.js';
import { useCSS } from '../../lib/hooks.js';

import { AutoPostImageUploader } from '../builder/ImageUploader.js';

const empty_avatar = '/img/no-foto_300x180.jpg';

const checkIfEnabled = () => {
	return window?.display_avatars ?? false;
};

const AvatarUploaderWrapper = (props) => {
	const type = props?.type ?? 'front';

	if(type == 'back') {
		return (
			props.children
		)
	}

	let avatar_styles = (props._styles != undefined) ? {...props._styles} : {};
	if(typeof width == 'number') {
		avatar_styles.width = `${width}px`;
		avatar_styles.height = `${height}px`;
		avatar_styles.flexBasis = `${width}px`;
	}
	
	let _class = ['avatar_uploader', 'gui_flex_forced_size'];
	if(props?.missing_avatar ?? false) _class.push('missing');
	if(props._class != undefined) _class.push(props._class);

	return (
		<span class={_class.join(" ")} style={avatar_styles}>
			{props.children}
		</span>
	)
};

export const UploadAvatar = (props) => {
	useCSS('comp/avatar.css');

	const width  = props?.width ?? 50;
	const small_input = props?.small_input ?? false;
	const single_stage = props?.single_stage ?? false;
	const is_builder = props?.is_builder ?? false;
	const use_empty_by_default = props?.use_empty_by_default ?? true;

	const [ avatar, setAvatar ] = useState((use_empty_by_default) ? empty_avatar : null);
	const [ error, setError ] = useState(false);
	const [ missing_avatar, setMissingAvatar ] = useState(false);

	const change = (k, v) => {
		if(k == 'avatar'){
			setError(false);
			if(!v){
				setError("Invalid format image");
				setTimeout(()=>setError(false),2000);
				return;
			}
		}

		if(props.change != undefined) props.change(k, v);
		if(k == 'avatar' && props.onChangeAvatar != undefined) props.onChangeAvatar();

		if(k == 'avatar') return;

		if(!single_stage) {
			[...document.querySelectorAll('.avatar_img')].map((avatar_instance) => {
				avatar_instance.src = (v != null && v != "") ? v : `${window?.static_domain_1 ?? '/'}img/blank_1x1.png`;
			});
		}

		setAvatar(v);
	};

	useEffect(() => {
		const _avatar = props.user.full_avatar ? props.user.full_avatar : props.user.avatar;

		if(_avatar == undefined || _avatar.indexOf('blank') !== -1) {
			if(use_empty_by_default) setAvatar(empty_avatar);
			setMissingAvatar(true);
		} else {
			setAvatar(_avatar);
			setMissingAvatar(false);
		}
	}, [ props.user.full_avatar, props.user.avatar ]);

	if(!checkIfEnabled()) return null;

	const input_classes = props?.input_classes ?? {};
	input_classes.first = props?.is_first ?? true;

	let display_actions = false;
	if(!missing_avatar && (props?.enable_actions ?? true)) display_actions = true;

	const auto_url = (single_stage && is_builder) ? `/promotions/auto_img/${props.user.promotion_id}` : `/promotions/upload_avatar/${props.user.promotion_id}`;

	return (
		<div class="gui_flexbox_auto gui_flex_col">
			<AvatarUploaderWrapper {...props} missing_avatar={missing_avatar}>
				<AutoPostImageUploader
					auto_url={auto_url}
					auto_type='avatars'
					_class={input_classes}
					name="avatar"
					image={avatar}
					change={change}
					is_builder={props.is_builder}
					_size={{width:400, height:400}}
					small_input={small_input}
					display_custom_dragging_instructions={(!error) ? (props.upload_message ?? "Upload") : error}
					thumb_w={(!small_input) ? (width - 2) : null}
					enable_actions={display_actions}
					_field_style={(error) ? { '--main-color':'var(--error-color)' } : null}
				>{props.children}</AutoPostImageUploader>
			</AvatarUploaderWrapper>
		</div>
	)
};

const UserAvatar = ({ user, ...props }) => {
	useCSS('comp/avatar.css');

	const force_avatar = user?.force_avatar ?? false;
	if(!force_avatar && !checkIfEnabled()) return null;

	const is_builder = props?.is_builder ?? false;
	const width = props?.width ?? false;
	const display_network_icon = props?.display_network_icon ?? false;

	const getNetworkIcon = () => {
		let network_icon = `ep-${user.network}`;

		if(isNotEmpty(user, 'net_type')) {
			switch(user.net_type) {
				case "0":
					return 'ep-mail';
				case "1":
					return 'ep-facebook-round';
				case '3':
					return 'ep-instagram';
				case '2':
					return 'ep-google';
				case '5':
					return 'ep-linked-in';
				case '6':
					return 'ep-twitch';
				case '8':
					return 'knk-iphone5-p';
				case '9':
					return 'ep-user';
				case '10':
					return 'ep-real-madrid';
				case '4':
				case '11':
				case '12':
				default:
					return false;
				case '13':
					return 'ep-tiktok';
			}
		}

		if(network_icon != 'ep-undefined') return false;

		return network_icon;
	}

	const network_icon = getNetworkIcon();

	let avatar_styles = null;
	if(width !== false) {
		avatar_styles = {
			'--avatar-size':`${width}em`,
			'--initials-size':'calc(0.7 * var(--avatar-size))',
		};
	}

	const blank_avatar = `${window?.static_domain_1 ?? '/'}img/blank_1x1.png`;
	let avatar_img = user?.avatar ?? false;
	const is_blocked = (avatar_img !== false && avatar_img.indexOf('blocked') > -1) ? true : false;
	const is_gravatar = (avatar_img !== false && avatar_img.indexOf('gravatar') > -1) ? true : false;

	const has_network_icon = (display_network_icon && network_icon !== false) ? true : false;
	const has_extra_icon = ((props?.extra_class ?? false) !== false) ? true : false;

	const has_extra_icons = (has_network_icon || has_extra_icon) ? true : false;

	let _main_classes = ['avatar_container'];
	if(has_extra_icons) _main_classes.push('with_extras');

	let _classes = ['gui_avatar'];
	if(is_builder && is_blocked) _classes.push('is_blocked');

	return (
		<div class={_main_classes.join(" ")} style={avatar_styles}>
			<span class={_classes.join(" ")}>
				{(!avatar_img || (is_blocked && (!is_builder || true)) || is_gravatar) && (
					<span class="icon">
						<span class="account_initials gui_pos_abs">{getInitials(user)}</span>
					</span>
				)}

				{(!is_blocked) && (
					<img class="avatar_img" src={avatar_img || blank_avatar} width='100%' height='100%' alt={user.name} />
				)}

				{(is_blocked && is_builder) && (
					<span class="avatar_img knk-blacklist" />
				)}
			</span>

			{(has_extra_icons) && (
				<span class="extra_icons">
					{(display_network_icon && network_icon !== false) && (
						<span class={`network_icon ${network_icon}`} />
					)}

					{((props?.extra_class ?? false) !== false) && (
						<span class={`extra_icon ${props.extra_class}`} />
					)}
				</span>
			)}
		</div>
	)
}

export default UserAvatar;